import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
interface BackButtonProps {
  signColor?: string;
}
export function BackButton({
  signColor = '#C9A84C'
}: BackButtonProps) {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/');
  };
  return <motion.button onClick={handleBack} className="fixed top-24 left-6 z-50 flex items-center space-x-2 px-4 py-2 rounded-lg bg-cosmic-darker border border-opacity-30 hover:border-opacity-60 transition-all" style={{
    borderColor: signColor
  }} whileHover={{
    scale: 1.05,
    boxShadow: `0 0 20px ${signColor}40`
  }} whileTap={{
    scale: 0.95
  }} data-id="element-198">
      <ArrowLeftIcon size={20} style={{
      color: signColor
    }} data-id="element-199" />
      <span className="text-sm font-medium" style={{
      color: signColor
    }} data-id="element-200">
        Volver
      </span>
    </motion.button>;
}